import React, { useEffect, useMemo, useState } from 'react';
import { Box, ButtonBase, Checkbox, Dialog, FormControlLabel, IconButton, Typography } from '@material-ui/core';
import _ from 'lodash';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import BedStatusIcon from '../../BedStatusIcon';
import { baseCssOccupieddischarge } from '../baseCss';
import Updatetoavailable from '../Updatetoavailable';
import Updatetotbc from '../Updatetotbc';
import bsApp, { bedP as P, remarkType } from '../../../bsApp';

export default function Available({ closePop, allData, open, updateBedStatus, saveBedStatus }) {
  const Remarks = [
    { text: i18n.t('BEDSTATUS_MAINTENANCE'), key: P.maintenance },
    { text: i18n.t('BEDSTATUS_RESUSCITATION'), key: P.resuscitation },
    { text: i18n.t('BEDSTATUS_LIFE_SAVING_EQUIPMENT'), key: P.lifeSavingEquipment },
    { text: 'Frozen', key: P.frozenYn },
  ];
  const baseClasses = baseCssOccupieddischarge();
  const [InputValue, setInputValue] = useState({
    [P.maintenance]: allData?.[P.maintenance],
    [P.resuscitation]: allData?.[P.resuscitation],
    [P.lifeSavingEquipment]: allData?.[P.lifeSavingEquipment],
    [P.frozenYn]: allData?.[P.frozenYn],
  });
  useEffect(() => {
    setInputValue({
      [P.maintenance]: allData?.[P.maintenance],
      [P.resuscitation]: allData?.[P.resuscitation],
      [P.lifeSavingEquipment]: allData?.[P.lifeSavingEquipment],
      [P.frozenYn]: allData?.[P.frozenYn],
    });
  }, [allData]);
  const changeHandle = (type, key) => {
    return (event) => {
      if (type === 'check') {
        setInputValue({ ...InputValue, [key]: Number(event.target.checked) });
      }
    };
  };

  const [isUpdateToTBC, setIsUpdateToTB] = useState(false);
  const updateToTBCHandler = () => {
    setIsUpdateToTB(true);
  };
  const closeUpdateToTBC = () => {
    setIsUpdateToTB(false);
  };

  const [isUpdatetoavailable, setIsUpdatetoavailable] = useState(false);
  const closeUpdatetoavailable = () => {
    return setIsUpdatetoavailable(false);
  };
  const updateAvailableHandler = () => {
    setIsUpdatetoavailable(true);
  };

  const saveRemarkHandler = async () => {
    console.log('saveRemarkHandler', InputValue);
    try {
      await saveBedStatus(
        {
          ...allData,
          ...InputValue,
          remarkType: remarkType.available,
        },
        closePop
      );
    } catch {}
  };

  const confirm_updateToTbc = async (data) => {
    // 灰色
    console.log('confirm_updateToTbc', data);
    try {
      await updateBedStatus(
        {
          ...allData,
          ...data,
          targetStatus: bsApp.TBC,
          sourceStatus: bsApp.UNAVAILABLE,
          ccWardCd: allData?.[P.ccWardCd],
        },
        closePop
      );
    } catch {}
  };

  const confirm_updatetoavailable = async () => {
    console.log('confirm_updatetoavailable');
    try {
      await updateBedStatus(
        {
          ...allData,
          targetStatus: bsApp.AVAILABLE,
          sourceStatus: bsApp.UNAVAILABLE,
        },
        closePop
      );
    } catch {}
  };

  const linkedBeds = useMemo(() => {
    if (allData.linkeds) {
      return [
        `${allData.ccWardCd} ${allData.bedNo}`,
        ..._.map(allData.linkeds, (item) => `${item.ccWardCd} ${item.bedNo}`),
      ];
    } else {
      return [];
    }
  }, [allData]);

  return (
    <>
      {!isUpdatetoavailable && !isUpdateToTBC ? (
        <Dialog open={open} maxWidth={false}>
          <div className={baseClasses.root}>
            <div className={baseClasses.header} style={{ padding: '2.063rem 1.56rem 1.688rem' }}>
              <Typography className={baseClasses.headerTitle}>{i18n.t('BEDSTATUS_BED_STATUS')}</Typography>
              <IconButton id="bed_available_close_btn" className={baseClasses.closeIcon} onClick={closePop}>
                <CloseIcon />
              </IconButton>
            </div>
            <Box overflow="auto" p="0 1.56rem 2.563rem" pb="2.563rem" display="flex" flexDirection="column">
              <Box className={baseClasses.statusBox} justifyContent="space-between" pl="1.563rem">
                <Typography className={baseClasses.labelText}>{i18n.t('BEDSTATUS_BED_NO')}</Typography>
                <div className={baseClasses.status}>
                  <BedStatusIcon allData={allData} disabled={true} />
                </div>
              </Box>
              {allData.linkeds && (
                <Box display="flex" alignItems="center" m="0.5rem 0">
                  <Typography className={baseClasses.labelText}>
                    Linked bed:
                    <span className={baseClasses.others} style={{ color: '#538fff', marginLeft: '0.5rem' }}>
                      {linkedBeds.join(', ')}
                    </span>
                  </Typography>
                </Box>
              )}
              <Typography className={baseClasses.others} style={{ margin: '1rem 0 0.5rem 0' }}>
                {i18n.t('BEDSTATUS_REMARKS')}
              </Typography>
              {_.map(Remarks, (item) => {
                return (
                  <span key={item.key}>
                    <FormControlLabel
                      id={`bed_available_${item.key}`}
                      control={<Checkbox />}
                      label={item.text}
                      className={baseClasses.checkBox}
                      style={{ marginTop: '0.2rem' }}
                      onChange={changeHandle('check', item.key)}
                      checked={Boolean(InputValue?.[item.key])}
                    />
                  </span>
                );
              })}
            </Box>
            <div className={baseClasses.bottom}>
              <ButtonBase
                id="bed_available_save_remark"
                className={baseClasses.cancelBtn}
                style={{ marginRight: '1.25rem' }}
                onClick={() => {
                  (async () => {
                    await saveRemarkHandler();
                  })();
                }}
              >
                {i18n.t('BEDSTATUS_SAVE_REMARK')}
              </ButtonBase>
              <ButtonBase
                id="bed_available_update_to_tbc"
                className={baseClasses.configBtn}
                style={{ marginRight: '1.25rem' }}
                onClick={updateToTBCHandler}
              >
                {i18n.t('BEDSTATUS_UPDATE_TO_TBC')}
              </ButtonBase>
              <ButtonBase
                id="bed_available_update_to_available"
                className={baseClasses.configBtn}
                style={{ background: '#28d2ab' }}
                onClick={updateAvailableHandler}
              >
                {i18n.t('BEDSTATUS_UPDATE_TO_AVAILABLE')}
              </ButtonBase>
            </div>
          </div>
        </Dialog>
      ) : (
        ''
      )}
      {isUpdateToTBC ? (
        <Updatetotbc
          allData={allData}
          open={isUpdateToTBC}
          closePop={closeUpdateToTBC}
          confirmHandle={confirm_updateToTbc}
        />
      ) : (
        ''
      )}
      {isUpdatetoavailable ? (
        <Updatetoavailable
          allData={allData}
          open={isUpdatetoavailable}
          closePop={closeUpdatetoavailable}
          confirmHanlder={confirm_updatetoavailable}
        />
      ) : (
        ''
      )}
    </>
  );
}
